"use client";

import { useEffect, useRef } from "react";
import type { DiscoveryBrowserState } from "@/lib/discovery/webmcp";

/** Ordinary browsers do not download the tool implementation or fetch any data. */
export function useDiscoveryWebMcp(state: DiscoveryBrowserState) {
  const latest = useRef(state);
  useEffect(() => { latest.current = state; }, [state]);

  useEffect(() => {
    if (!("modelContext" in document) && !("modelContext" in navigator)) return;
    let disposed = false;
    let cleanup: (() => void) | undefined;
    void import("@/lib/discovery/webmcp").then(({ getNativeModelContext, createDiscoveryTools, registerDiscoveryTools }) => {
      if (disposed) return;
      const context = getNativeModelContext(document, navigator);
      if (context) cleanup = registerDiscoveryTools(context, createDiscoveryTools(() => latest.current));
    }).catch((error) => {
      // Keep experimental tooling optional while making local integration
      // failures visible to developers who have enabled the native capability.
      if (process.env.NODE_ENV === "development") console.warn("Unable to initialize finda.show WebMCP tools", error);
    });
    return () => { disposed = true; cleanup?.(); };
  }, []);
}
